import React, { useEffect, useId, useRef, useState } from 'react'
import MapaPolski from '../wykonawcy/MapaPolski'
import { REGIONY } from '../wykonawcy/regionyPolski'
import Ikona from './IkonaZlecenia'

/**
 * Województwo z mapy (makieta 12, D19): pole jak lista rozwijana otwiera okienko z mapą Polski z wyboru wykonawcy
 * (`components/wykonawcy/MapaPolski.tsx`). Klawiatura: województwa są przyciskami (Tab, Enter, spacja), Escape zamyka
 * i wraca do pola; klik poza okienkiem też zamyka.
 */
const WyborWojewodztwa = ({ wartosc, onZmiana, blad = false, etykieta = 'Województwo' }) => {
  const [otwarte, setOtwarte] = useState(false)
  const pole = useRef(null)
  const ramka = useRef(null)
  const id = useId()
  const nazwa = REGIONY.find((r) => r.key === wartosc)?.nazwa

  useEffect(() => {
    if (!otwarte) return undefined
    const mapa = ramka.current
    const start = mapa?.querySelector('.vv-mapa__region--wybrany') || mapa?.querySelector('[role="button"]')
    start?.focus()
    const klik = (e) => { if (!ramka.current?.parentElement?.contains(e.target)) setOtwarte(false) }
    const klawisz = (e) => {
      if (e.key === 'Escape') { e.stopPropagation(); setOtwarte(false); pole.current?.focus() }
    }
    document.addEventListener('mousedown', klik)
    document.addEventListener('keydown', klawisz)
    return () => {
      document.removeEventListener('mousedown', klik)
      document.removeEventListener('keydown', klawisz)
    }
  }, [otwarte])

  const wybierz = (klucz) => {
    // Klik w już wybrane województwo w mapie zwalnia wybór; tutaj tylko zamyka okienko z tym samym wyborem.
    if (klucz) onZmiana(klucz)
    setOtwarte(false)
    pole.current?.focus()
  }

  return (
    <div className="pole pole-woj">
      <span id={`${id}-e`}>{etykieta}</span>
      <button ref={pole} type="button" id={`${id}-p`} className="wejscie wybor-woj" aria-labelledby={`${id}-e ${id}-p`}
              aria-haspopup="dialog" aria-expanded={otwarte} aria-controls={`${id}-m`} data-blad={blad || undefined}
              onClick={() => setOtwarte((o) => !o)}>
        <span className={nazwa ? '' : 'pusty'}>{nazwa || 'Wybierz'}</span>
        <Ikona nazwa="dol" rozmiar={16} grubosc={2.4} />
      </button>
      {otwarte && (
        <div ref={ramka} className="mapa-pop" id={`${id}-m`} role="dialog" aria-label="Wybierz województwo na mapie">
          <MapaPolski wybrany={wartosc || null} onWybierz={wybierz} zacheta="Kliknij województwo" />
        </div>
      )}
    </div>
  )
}

export default WyborWojewodztwa
